// 11 layout types; total = number of grid slots
export const LAYOUT_TYPES = [
  { key: "1x1",     label: "1 × 1",     cols: 1, rows: 1, total: 1  },
  { key: "1x2",     label: "1 × 2",     cols: 1, rows: 2, total: 2  },
  { key: "2x1",     label: "2 × 1",     cols: 2, rows: 1, total: 2  },
  { key: "2x2",     label: "2 × 2",     cols: 2, rows: 2, total: 4  },
  { key: "6grids",  label: "6 Grids",   cols: null,       total: 6  },
  { key: "8grids",  label: "8 Grids",   cols: null,       total: 8  },
  { key: "3x3",     label: "3 × 3",     cols: 3, rows: 3, total: 9  },
  { key: "10grids", label: "10 Grids",  cols: null,       total: 10 },
  { key: "13grids", label: "13 Grids",  cols: null,       total: 13 },
  { key: "14grids", label: "14 Grids",  cols: null,       total: 14 },
  { key: "4x4",     label: "4 × 4",     cols: 4, rows: 4, total: 16 },
];

/**
 * Dev-only stream token override (local camera bring-up).
 * Real deployments should use portal authToken or per-device API tokens.
 * Set in .env: REACT_APP_LIVEVIEW_DEV_ACCESS_TOKEN=...
 * Falcon endpoint: REACT_APP_FALCON_URL (or derived from REACT_APP_WEBSOCKET_URL).
 */
export const LIVEVIEW_STREAM_CONFIG = {
  streamId: 1,
  doesOpenRelay: true,
};

// TODO: replace with API call
// cameras[].slotIndex = position of the camera in the layout grid (0-based)
export const MOCK_VIEWS = [
  {
    id: 1,
    name: "View 1",
    layout: "2x2",
    cameras: [
      { cameraId: "cam-001", slotIndex: 0 },
      { cameraId: "cam-002", slotIndex: 1 },
      { cameraId: "cam-003", slotIndex: 3 },
    ],
  },
  {
    id: 2,
    name: "View 2",
    layout: "3x3",
    cameras: [
      { cameraId: "cam-004", slotIndex: 0 },
      { cameraId: "cam-005", slotIndex: 2 },
      { cameraId: "cam-006", slotIndex: 4 },
      { cameraId: "cam-007", slotIndex: 8 },
    ],
  },
  {
    id: 3,
    name: "View 3",
    layout: "1x1",
    cameras: [
      { cameraId: "00:1C:27:27:97:BA", slotIndex: 0 },
    ],
  },
  {
    id: 4,
    name: "View 4",
    layout: "4x4",
    cameras: [
      { cameraId: "cam-009", slotIndex: 0 },
      { cameraId: "cam-010", slotIndex: 1 },
      { cameraId: "cam-011", slotIndex: 4 },
      { cameraId: "cam-012", slotIndex: 5 },
    ],
  },
  {
    id: 5,
    name: "View 5",
    layout: "6grids",
    cameras: [
      { cameraId: "cam-013", slotIndex: 0 },
      { cameraId: "cam-014", slotIndex: 1 },
      { cameraId: "cam-015", slotIndex: 2 },
    ],
  },
  {
    id: 6,
    name: "View 6",
    layout: "2x1",
    cameras: [
      { cameraId: "cam-001", slotIndex: 0 },
      { cameraId: "cam-002", slotIndex: 1 },
    ],
  },
];

// TODO: replace with API call
export const MOCK_DEVICES = [
  { id: "00:1C:27:27:97:BA", name: "Cam-01", favorited: false, accessToken: "local-test-token" },
  { id: "cam-002", name: "Cam-02", favorited: false, accessToken: "" },
  { id: "cam-003", name: "Cam-03", favorited: true,  accessToken: "" },
  { id: "cam-004", name: "Cam-04", favorited: false },
  { id: "cam-005", name: "Cam-05", favorited: false },
  { id: "cam-006", name: "Cam-06", favorited: false },
  { id: "cam-007", name: "Cam-07", favorited: true  },
  { id: "cam-008", name: "Cam-08", favorited: false },
  { id: "cam-009", name: "Cam-09", favorited: false },
  { id: "cam-010", name: "Cam-10", favorited: true  },
  { id: "cam-011", name: "Cam-11", favorited: false },
  { id: "cam-012", name: "Cam-12", favorited: false },
  { id: "cam-013", name: "Cam-13", favorited: true  },
  { id: "cam-014", name: "Cam-14", favorited: false },
  { id: "cam-015", name: "Cam-15", favorited: false },
];

// TODO: replace with API call
export const MOCK_NVRS = [
  {
    id: "nvr-001",
    name: "NVR-01",
    cameras: [
      { id: "nvr-cam-001", name: "Cam-N01", favorited: false },
      { id: "nvr-cam-002", name: "Cam-N02", favorited: false },
      { id: "nvr-cam-003", name: "Cam-N03", favorited: false },
    ],
  },
  {
    id: "nvr-002",
    name: "NVR-02",
    cameras: [
      { id: "nvr-cam-004", name: "Cam-N04", favorited: false },
      { id: "nvr-cam-005", name: "Cam-N05", favorited: false },
    ],
  },
  {
    id: "nvr-003",
    name: "NVR-03",
    cameras: [
      { id: "nvr-cam-006",  name: "Cam-N06",  favorited: false },
      { id: "nvr-cam-007",  name: "Cam-N07",  favorited: false },
      { id: "nvr-cam-008",  name: "Cam-N08",  favorited: false },
      { id: "nvr-cam-009",  name: "Cam-N09",  favorited: false },
      { id: "nvr-cam-010",  name: "Cam-N10",  favorited: false },
      { id: "nvr-cam-011",  name: "Cam-N11",  favorited: false },
      { id: "nvr-cam-012",  name: "Cam-N12",  favorited: false },
      { id: "nvr-cam-013",  name: "Cam-N13",  favorited: false },
      { id: "nvr-cam-014",  name: "Cam-N14",  favorited: false },
      { id: "nvr-cam-015",  name: "Cam-N15",  favorited: false },
      { id: "nvr-cam-016",  name: "Cam-N16",  favorited: false },
    ],
  },
];
